import { jsx as o, jsxs as C } from "react/jsx-runtime";
import { Paper as z, Box as a, Tooltip as l, IconButton as t } from "@mui/material";
import { S as L, L as B } from "./Satellite.js";
import { c } from "./createSvgIcon.js";
import { F, a as M } from "./FullscreenExit.js";
import { mapContainerStyles as i } from "../components/OverlayMap/styles.js";
const b = c(/* @__PURE__ */ o("path", {
  d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"
}), "Visibility"), O = c(/* @__PURE__ */ o("path", {
  d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7M2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2m4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3z"
}), "VisibilityOff"), P = c(/* @__PURE__ */ o("path", {
  d: "M6 13c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4m6-10C9.8 3 8 4.8 8 7s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4m6 10c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4"
}), "Workspaces"), R = c(/* @__PURE__ */ o("path", {
  d: "M6 15c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-2c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4m6-8c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-2C9.8 3 8 4.8 8 7s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4m6 12c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-2c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4"
}), "WorkspacesOutlined"), V = ({
  currentViewMode: e,
  isOverlayHidden: n,
  // overlayOpacity,
  onViewModeChange: p,
  onOverlayVisibilityToggle: u,
  // onOpacityChange,
  miniControlsMainStyles: f,
  hasFloorPlan: d,
  hasRFPlan: x,
  onFullscreenToggle: I,
  isFullscreen: s,
  showFullscreenToggle: h = !0,
  showCirclesControl: k,
  setShowCircles: m,
  showCircles: r,
  hasOverlays: y
}) => /* @__PURE__ */ C(
  z,
  {
    elevation: 2,
    sx: [i.miniControlsPaper, f || {}],
    children: [
      h && /* @__PURE__ */ o(a, { sx: i.miniControlsRow, children: /* @__PURE__ */ o(
        l,
        {
          title: s ? "Exit Fullscreen" : "Enter Fullscreen",
          children: /* @__PURE__ */ o(
            t,
            {
              onClick: I,
              size: "small",
              color: s ? "primary" : "default",
              sx: i.miniControlButton,
              children: s ? /* @__PURE__ */ o(F, { sx: i.miniControlIcon }) : /* @__PURE__ */ o(M, { sx: i.miniControlIcon })
            }
          )
        }
      ) }),
      /* @__PURE__ */ o(a, { sx: i.expandedControls, children: /* @__PURE__ */ C(a, { sx: i.miniControlsGroup, children: [
        k && /* @__PURE__ */ o(l, { title: `${r ? "Hide" : "Expand"} Radio Groups`, children: /* @__PURE__ */ o(
          t,
          {
            onClick: () => m == null ? void 0 : m(!r),
            size: "small",
            color: r ? "primary" : "default",
            sx: i.miniControlButton,
            children: r ? /* @__PURE__ */ o(P, { fontSize: "small" }) : /* @__PURE__ */ o(R, { fontSize: "small" })
          }
        ) }),
        d && /* @__PURE__ */ o(l, { title: "Floor Plan", children: /* @__PURE__ */ o(
          t,
          {
            onClick: () => p("FLOOR_PLAN"),
            size: "small",
            color: e === "FLOOR_PLAN" && !n ? "primary" : "default",
            sx: i.miniControlButton,
            disabled: !d,
            children: /* @__PURE__ */ o(L, { sx: i.miniControlIcon })
          }
        ) }),
        x && /* @__PURE__ */ o(l, { title: "RF Plan", children: /* @__PURE__ */ o(
          t,
          {
            onClick: () => p("RF_PLAN"),
            size: "small",
            color: e === "RF_PLAN" && !n ? "primary" : "default",
            sx: i.miniControlButton,
            disabled: !x,
            children: /* @__PURE__ */ o(B, { sx: i.miniControlIcon })
          }
        ) }),
        y && /* @__PURE__ */ o(l, { title: n ? "Show Overlay" : "Hide Overlay", children: /* @__PURE__ */ o(
          t,
          {
            onClick: u,
            size: "small",
            color: n ? "primary" : "default",
            sx: i.miniControlButton,
            children: n ? /* @__PURE__ */ o(b, { sx: i.miniControlIcon }) : /* @__PURE__ */ o(O, { sx: i.miniControlIcon })
          }
        ) })
      ] }) })
    ]
  }
);
export {
  V as M,
  O as V,
  b as a
};
